/* eslint-disable no-unused-vars */
/* eslint-disable  react/display-name */
import { Button, Grid, IconButton, Tooltip, Typography } from "@mui/material";
import HomeIcon from "@mui/icons-material/Home";
import PCard from "../../../components/pos/PCard.jsx";
import Select from "../../../components/pos/PSelect";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import API from "../../../utils/API";
import MUIDataTable from "mui-datatables";
import PSelect from "../../../components/pos/PSelect";

export default function AccountingGeneralSettings(props) {
  const { t } = useTranslation();
  const translate = t;
  const [id, setId] = useState("");
  const [selectedBankAccount, setSelectedBankAccount] = useState("");
  const [selectedCashAccount, setSelectedCashAccount] = useState("");
  const [selectedSaleAccount, setSelectedSaleAccount] = useState("");
  const [selectedPurchaseAccount, setSelectedPurchaseAccount] = useState("");
  const [bankLedgers, setBankLedgers] = useState([]);
  const [cashLedgers, setCashLedgers] = useState([]);
  const [purchaseAccountLedgers, setPurchaseAccountLedgers] = useState([]);
  const [saleAccountLedgers, setSaleAccountLedgers] = useState([]);
  const [payCodeLedgers, setPayCodeLedgers] = useState([]);
  const [additionalPayCodes, setAdditionalPayCodes] = useState([]);

  useEffect(() => {
    loadData();
    populatedata();
  }, []);

  var biRef = {};

  function loadData() {
    populateAdditionalPayCodes();
    populateLedgerOptions();
  }

  async function populateAdditionalPayCodes() {
    let { data } = await API.get("/api/v1/additionalpaycodes");
    let payCodeList = [];
    data.forEach((element) => {
      console.log(JSON.stringify(element));
      payCodeList.push({
        name: element.payCodeName,
        id: element.id,
        ledger: {
          name:
            element.payCodeLedgerName == null ? "" : element.payCodeLedgerName,
          id: element.payCodeLedgerId == null ? "" : element.payCodeLedgerId,
        },
      });
    });
    setAdditionalPayCodes(payCodeList);
  }

  async function populatedata() {
    let { data } = await API.get("/api/v1/accountgeneralsetting");
    setId(data.id);
    setSelectedPurchaseAccount({
      id: data.defaultPurchaseAccountId,
      name: data.defaultPurchaseAccountName,
    });
    setSelectedSaleAccount({
      id: data.defaultSaleAccountId,
      name: data.defaultSaleAccountName,
    });
    setSelectedCashAccount({
      id: data.defaultCashAccountId,
      name: data.defaultCashAccountName,
    });
    setSelectedBankAccount({
      id: data.defaultBankAccountId,
      name: data.defaultBankAccountName,
    });
  }

  async function populateLedgerOptions() {
    let { data } = await API.get("/api/v1/ledgerlist");
    setPurchaseAccountLedgers([]);
    setSaleAccountLedgers([]);
    setCashLedgers([]);
    setBankLedgers([]);
    let purchaseAccountOptions = [];
    let saleAccountOptions = [];
    let cashAccountOptions = [];
    let bankAccountOptions = [];
    let additionalPayCodeOptions = [];
    for (let i = 0; i < data.length; i++) {
      if (data[i].code.startsWith("01") || data[i].code.startsWith("04")) {
        additionalPayCodeOptions.push({ id: data[i].id, name: data[i].name });
      }
      if (data[i].code.startsWith("0303")) {
        purchaseAccountOptions.push({ id: data[i].id, name: data[i].name });
      } else if (data[i].code.startsWith("0403")) {
        saleAccountOptions.push({ id: data[i].id, name: data[i].name });
      } else if (data[i].code.startsWith("010103")) {
        cashAccountOptions.push({ id: data[i].id, name: data[i].name });
      } else if (data[i].code.startsWith("010102")) {
        bankAccountOptions.push({ id: data[i].id, name: data[i].name });
      }
    }
    setPurchaseAccountLedgers(purchaseAccountOptions);
    setSaleAccountLedgers(saleAccountOptions);
    setCashLedgers(cashAccountOptions);
    setBankLedgers(bankAccountOptions);
    setPayCodeLedgers(additionalPayCodeOptions);
  }

  async function onSave() {
    console.log(JSON.stringify(additionalPayCodes));
    let payload = createPayload();
    try {
      let result = await API.post("/api/v1/accountgeneralsettings", payload);
      props.showMessage("success", "Saved Successfully");
    } catch (err) {
      if (err.response && err.response.status == 412) {
        showDetailedError(err.response.data);
      } else {
        props.showMessage("error", "Not able to Save Accountingsettings");
      }
    }
    additionalPayCodeEntries(additionalPayCodes);
  }

  function showDetailedError(err) {}

  function additionalPayCodeEntries(data) {
    data.forEach((paycode) => {
      let saveObject = Object.create(null);
      saveObject["id"] = paycode.id;
      saveObject["payCodeName"] = paycode.name;
      saveObject["payCodeLedgerId"] = paycode.ledger.id;
      saveObject["payCodeLedgerName"] = paycode.ledger.name;
      savePayCodeMapping(saveObject);
    });
  }

  async function savePayCodeMapping(payLoad) {
    try {
      let result = await API.post("/api/v1/additionalpaycodes", payLoad);
      props.showMessage("success", "Saved Successfully");
    } catch (err) {
      if (err.response && err.response.status === 412) {
        showDetailedError(err.response.data);
      } else {
        props.showMessage("error", "Not able to Save Paycode Settings");
      }
    }
  }

  function createPayload() {
    let saveObject = Object.create(null);
    saveObject["id"] = id;
    saveObject["defaultBankAccountId"] = selectedBankAccount.id;
    saveObject["defaultBankAccountName"] = selectedBankAccount.name;

    saveObject["defaultCashAccountId"] = selectedCashAccount.id;
    saveObject["defaultCashAccountName"] = selectedCashAccount.name;

    saveObject["defaultPurchaseAccountId"] = selectedPurchaseAccount.id;
    saveObject["defaultPurchaseAccountName"] = selectedPurchaseAccount.name;

    saveObject["defaultSaleAccountId"] = selectedSaleAccount.id;
    saveObject["defaultSaleAccountName"] = selectedSaleAccount.name;

    return saveObject;
  }

  const columns = [
    {
      name: "name",
      options: {
        filter: false,
        sort: false,
        setCellHeaderProps: () => ({ align: "center" }),
        setCellProps: () => ({ align: "center" }),
        customBodyRender: (value, tableMeta, updateValue) => (
          <div>
            <Typography variant="body1">{value}</Typography>
          </div>
        ),
      },
    },
    {
      name: "ledger",
      label: translate("Ledger"),
      options: {
        setCellHeaderProps: () => ({ align: "center", width: "70%" }),
        setCellProps: () => ({ align: "center" }),
        filter: false,
        sort: false,
        customBodyRender: (value, tableMeta, updateValue) => {
          console.log("paycode: " + JSON.stringify(value));
          return (
            <div style={{ width: "70%", marginLeft: "15%" }}>
              <PSelect
                options={payCodeLedgers}
                value={value}
                onChange={(event, newValue) => {
                  let tempData = [...tableMeta.tableData];
                  tempData[tableMeta.rowIndex].ledger = newValue;
                  setAdditionalPayCodes(tempData);
                }}
              ></PSelect>
            </div>
          );
        },
      },
    },
  ];

  const options = {
    filterType: null,
    search: false,
    download: false,
    print: false,
    viewColumns: false,
    filter: false,
    pagination: false,
    selectableRows: "false",
    selectableRowsHeader: true,
    selectableRowsHideCheckboxes: true,
    tableBodyMaxHeight: "100%",
  };

  const content = (
    <Grid container style={{ height: "100%" }}>
      <Grid item xs={12} style={{ height: "5%" }}>
        <table width="100%">
          <tbody>
            <tr>
              <td>
                <Typography variant="body1">
                  {translate("Default Bank Account")}
                </Typography>
              </td>
              <td width="30%" style={{ marginRight: 30 }}>
                <Select
                  value={selectedBankAccount}
                  options={bankLedgers}
                  onChange={(e, value) => setSelectedBankAccount(value)}
                ></Select>
              </td>
              <td width="5%" />
              <td>
                <Typography variant="body1">
                  {translate("Default Cash Account")}
                </Typography>
              </td>
              <td width="30%">
                <Select
                  value={selectedCashAccount}
                  options={cashLedgers}
                  onChange={(e, value) => setSelectedCashAccount(value)}
                ></Select>
              </td>
            </tr>
            <tr>
              <td>
                <Typography variant="body1">
                  {translate("Default Purchase Account")}
                </Typography>
              </td>
              <td>
                <Select
                  value={selectedPurchaseAccount}
                  options={purchaseAccountLedgers}
                  onChange={(e, value) => setSelectedPurchaseAccount(value)}
                ></Select>
              </td>
              <td />
              <td>
                <Typography variant="body1">
                  {translate("Default  Sale Account")}
                </Typography>
              </td>
              <td>
                <Select
                  value={selectedSaleAccount}
                  options={saleAccountLedgers}
                  onChange={(e, value) => setSelectedSaleAccount(value)}
                ></Select>
              </td>
            </tr>
          </tbody>
        </table>
        <Grid item xs={12} sm={12} style={{ marginTop: 30 }}>
          <MUIDataTable
            title={<b>{translate("Additional Paycodes")}</b>}
            data={additionalPayCodes}
            columns={columns}
            options={options}
          />
        </Grid>

        <Button
          color="primary"
          variant="contained"
          style={{ marginTop: 30 }}
          onClick={onSave}
        >
          {translate("Apply")}
        </Button>
      </Grid>
    </Grid>
  );

  const customTitle = (
    <div>
      <table width="100%">
        <tbody>
          <tr>
            <td>{translate("General Settings")}</td>
          </tr>
        </tbody>
      </table>
    </div>
  );
  return <PCard avatar="A" title={customTitle} content={content}></PCard>;
}
